import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import {
  CheckoutCustomerDetailsComponent,
  CheckoutProgressionStepsComponent,
} from '@checkout/feature-components';
import {
  ProtectionConfirmationPanelComponent,
  ProtectionConfirmationPanelHeaderComponent,
} from '@checkout/ui-components';
import { CmsArea } from '@domgen/dgx-fe-cms';
import { CardComponent } from '@domgen/dgx-fe-components/card';
import {
  GridColumnComponent,
  GridContainerComponent,
  GridRowComponent,
  GridSectionComponent,
} from '@domgen/dgx-fe-components/grid';
import { GAPage } from '@domgen/dgx-fe-ga';
import { EditableArea } from '@magnolia/angular-editor';
import { MentionMeService } from '../../services/mention-me/mention-me.service';
import { OrderConfirmationComponentService } from '../../services/order-confirmation/order-confirmation-component.service';

@Component({
  templateUrl: './order-confirmation.component.html',
  styleUrls: ['./order-confirmation.component.scss'],
  providers: [OrderConfirmationComponentService, MentionMeService],
  standalone: true,
  imports: [
    AsyncPipe,
    CardComponent,
    CheckoutCustomerDetailsComponent,
    CheckoutProgressionStepsComponent,
    EditableArea,
    GridColumnComponent,
    GridContainerComponent,
    GridRowComponent,
    GridSectionComponent,
    NgFor,
    NgIf,
    ProtectionConfirmationPanelComponent,
    ProtectionConfirmationPanelHeaderComponent,
  ],
})
@GAPage()
export class OrderConfirmationComponent {
  @Input() banner!: CmsArea;
  @Input() main!: CmsArea;

  constructor(readonly cs: OrderConfirmationComponentService) {}
}
